import React from 'react';
import { GlobalPopupConfirmRef } from 'src/components/GlobalPopupConfirm';
class PopupService {
  static instance: React.MutableRefObject<GlobalPopupConfirmRef>;
}

export default PopupService;
